var map = {
	"./car.ts": "l9Zd",
	"./store.ts": "+EBM",
	"./user.ts": "CEE0",
	"./vip.ts": "ChiO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gmC9";


//////////////////
// WEBPACK FOOTER
// ./src/routers nonrecursive \.ts$
// module id = gmC9
// module chunks = 44